/**
 * Sprünge innerhalb der Projektseite — ohne dass die Teile voneinander wissen.
 *
 * Die Sprungleiste (Telefon) öffnet eine Sektion, die KI-Spur springt zu einer
 * Mail im Verlauf. Beides läuft über ein Fenster-Ereignis:
 * wer das Ziel kennt, hört zu; wer springen will, ruft nur die Funktion.
 */

import { SEKTION_EREIGNIS } from "@vimaana/ui";

// Sektion und Sprungleiste liegen seit 09.10.2026 gemeinsam mit der Pflege in
// @vimaana/ui (components/Sektion.tsx); hier bleibt der Sprung zu einer Mail.
export { SEKTION_EREIGNIS, zuSektion } from "@vimaana/ui";
export const MAIL_EREIGNIS = "vg-mail-zeigen";

/** Eine Mail im Verlauf zeigen: Sektion „Verlauf" öffnen, das Gespräch aufklappen, hinscrollen. */
export function zuMail(mailId: string): void {
  window.dispatchEvent(new CustomEvent(SEKTION_EREIGNIS, { detail: "verlauf" }));
  // Die Sektion rendert ihren Inhalt erst beim Aufklappen — dem Verlauf einen Moment geben.
  window.setTimeout(() => {
    window.dispatchEvent(new CustomEvent(MAIL_EREIGNIS, { detail: mailId }));
    window.setTimeout(() => {
      const ziel = document.getElementById(`mail-${mailId}`) || document.getElementById("sek-verlauf");
      ziel?.scrollIntoView({ behavior: "smooth", block: "center" });
      ziel?.classList.add("ist-gezeigt");
      window.setTimeout(() => ziel?.classList.remove("ist-gezeigt"), 2400);
    }, 250);
  }, 400);
}
